import React from "react"
// import Button from "components/Button"
import { useLocale } from "context/locale"

import StyledStrategyHeader from "./styles"

const StrategyHeader = () => {
  const { t } = useLocale()

  return (
    <StyledStrategyHeader>
      <h1 className="title">{t("Our strategy")}</h1>
      {/* <div
        className="desc"
        dangerouslySetInnerHTML={{
          __html: `<p>${t(
            "Poniżej prezentujemy strategię na lata 2020-2026. Obecnie pracujemy nad jej aktualizacją."
          )}</p>`,
        }}
      />
      <Button
        text={t("Download")}
        as="link-out"
        href={t("our_strategy_file")}
        variant="download-dark"
      /> */}
    </StyledStrategyHeader>
  )
}

export default StrategyHeader
